module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-paper', {
    staticClass: "bottomNav"
  }, [_c('mu-bottom-nav', {
    attrs: {
      "value": _vm.bottomNav
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_c('mu-bottom-nav-item', {
    attrs: {
      "value": "首页",
      "title": "首页",
      "icon": "home",
      "to": "/vue-home/dist"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    attrs: {
      "value": "信息",
      "title": "信息",
      "icon": "email",
      "to": "/vue-home/dist/message"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    attrs: {
      "value": "我的",
      "title": "我的",
      "icon": "person",
      "to": _vm.person_path
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    attrs: {
      "value": "更多",
      "title": "更多",
      "icon": "more",
      "to": "/vue-home/dist/more"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-085a5d05"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterNav.vue
// module id = 135
// module chunks = 1